// extracted by mini-css-extract-plugin
export default {"dark":"dark-3d1b"};